import { useContext } from "preact/compat";
import { GlobalContext } from "@/context/GlobalContext";
import DOMPurify from "dompurify";
import { createPortal } from "react-dom";
import useLocalStorageState from "use-local-storage-state";
import useLocationDrawer from "@/hooks/useLocationDrawer";
import { getDayOfWeek, getOpenTime, getCloseTime, isLocationCurrentlyOpen } from '@/Utils';
import OpenDotIcon from "@/icons/open-dot-icon.svg";
import ClosedDotIcon from "@/icons/closed-dot-icon.svg";

const LocationToggle = () => {
	const dayOfWeek = getDayOfWeek();
	let isOpen;
	let opensAt;
	let closesAt;
	let today;
	const toggleLocationDrawer = useLocationDrawer();
	const { locationSelectorOpen, setLocationSelectorOpen } = useContext(GlobalContext);
	const target = document.querySelector(".site-header-top");
	const [dutchieRetailer, setDutchieRetailer] = useLocalStorageState("dutchie_retailer", null);
	const myLocation = dutchie.retailers.find(
		(location) => location.id === dutchieRetailer?.id
	);

	const name = DOMPurify.sanitize(dutchieRetailer?.name);

	if ( myLocation && myLocation.hours.pickup )  {
		today = myLocation.hours.pickup[dayOfWeek];
		isOpen = isLocationCurrentlyOpen( today );
		opensAt = getOpenTime( today );
		closesAt = getCloseTime( today );
	}

	if (!target) {
		return null;
	}

	return createPortal(
		<>
		<div className="site-nav-hours">
			{isOpen ? (
				<>
					<OpenDotIcon />
					<strong className="status open">Order until</strong> <strong className="time">{closesAt}</strong>
				</>
			) : (
				<>
					<ClosedDotIcon />
					<strong className="status closed">Order at </strong> | <strong className="time">{opensAt}</strong>
				</>
			)}
		</div>
			<button
				onClick={toggleLocationDrawer}
				className="site-nav-location-selector btn-reset"
				aria-controls="location-selector"
				aria-expanded={locationSelectorOpen}
			>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#a)"><path d="M7.999 1.333A4.668 4.668 0 0 0 3.332 6c0 3.5 4.667 8.667 4.667 8.667S12.665 9.5 12.665 6A4.668 4.668 0 0 0 8 1.333Zm0 6.334a1.667 1.667 0 1 1 0-3.335 1.667 1.667 0 0 1 0 3.335Z" fill="#F7F5E1"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
					<span>{dutchieRetailer?.name || 'Select Location'}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M12 1.70655L10.5867 0.293213L6 4.87988L1.41333 0.293212L-6.17788e-08 1.70655L6 7.70655L12 1.70655Z" fill="#F7F5E1"/></svg>
			</button>
		</>,
		target
	);
};
export default LocationToggle;
